import React from 'react'
import { Routes, Route } from "react-router";
import { SignInPage } from "../../pages/SignInPage";
import { SignUpPage } from "../../pages/SignUpPage";
import { ForgotPasswordPage } from "../../pages/ForgotPasswordPage";
import { ConfirmSignupPage } from '../../pages/ConfirmSignupPage';
import { VerificationNoticePage } from '../../pages/VerificationNoticePage';
import { VerifyLinkPage } from '../../pages/VerifyLinkPage';

export const AuthSection = () => {
    return (
        <Routes>
            <Route path="/" element={<SignInPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/forgotpassword" element={<ForgotPasswordPage />} />
            <Route path="/confirm-signup/:username" element={<ConfirmSignupPage />} />
            <Route path="/verification-sent/" element={<VerificationNoticePage />} />
            <Route path="/verify/" element={<VerifyLinkPage />} />
        </Routes>
    )
}
